export enum RelatedPromptsTypeEnum {
  CURATED = 'CURATED',
  SYNTHETIC = 'SYNTHETIC',
}
